module.exports = __webpack_public_path__ + "img/feature_d04.9f743065.svg";